import { useMemo } from "react";
import { calculateRescuePricing, DEFAULT_RESCUE_PRICING_CONFIG, } from "../services/pricing.js";
export function useRescuePricing(input) {
    return useMemo(() => {
        const config = input.config || DEFAULT_RESCUE_PRICING_CONFIG;
        return calculateRescuePricing({ ...input, config });
    }, [input.distanceMiles, input.priority, input.isNight, input.isHoliday, input.config, input.minimums]);
}
//# sourceMappingURL=useRescuePricing.js.map